import { render, staticRenderFns } from "./MimdgForm.vue?vue&type=template&id=36e8fa6c"
import script from "./MimdgForm.vue?vue&type=script&lang=js"
export * from "./MimdgForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports